'use strict';

var _ = require('lodash');
var FlightPostDepartureDataService = function FlightPostDepartureDataService($q, restangular) {
  var updateIgnorePostDepartureStatus = function updateIgnorePostDepartureStatus(selectedRows) {
    return restangular.one('configured/flights/ignorePostDeparture').patch({
      value: prepareRequests(selectedRows)
    });
  };
  var prepareRequests = function prepareRequests(selectedRows) {
    return _.transform(selectedRows, function (result, row) {
      var marketOD = _.split(row.leg, '-');
      return result.push({
        origin: marketOD[0],
        destination: marketOD[1],
        cabinCode: row.cabinCode,
        legDepartureDate: row.legDepartureDateMoment.toISOString(),
        flightNumber: row.flightNumber,
        carrier: row.carrier,
        numberDepartureDate: row.flightDepartureDateMoment.toISOString(),
        opsSuffix: row.opsSuffix,
        ignorePostDepartureDataStatus: row.ignorePostDepartureDataStatus
      });
    });
  };
  return {
    updateIgnorePostDepartureStatus: updateIgnorePostDepartureStatus,
    prepareRequests: prepareRequests
  };
};
FlightPostDepartureDataService.$inject = ['$q', 'Restangular'];
module.exports = FlightPostDepartureDataService;